import { render, staticRenderFns } from "./AccountDesktop.vue?vue&type=template&id=28761205&lang=pug"
import script from "./AccountDesktop.vue?vue&type=script&lang=js"
export * from "./AccountDesktop.vue?vue&type=script&lang=js"
import style0 from "./AccountDesktop.vue?vue&type=style&index=0&id=28761205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports